import { render, staticRenderFns } from "./ProductVariantForm.vue?vue&type=template&id=17d05819&"
import script from "./ProductVariantForm.vue?vue&type=script&lang=js&"
export * from "./ProductVariantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports